import PathLink from './PathLink.js';
import $ from 'jquery';
class PathNode { 
  constructor(name, x, y, floorIndex) {
    this.name = name;
    this.x = x;
    this.y = y;
    this.floorIndex = floorIndex;
    this.type = 'pathNode';
    this.links = [];
    this.IsInCl;
    this.BestDist;
    this.BestLink;
  }
  
  connectTo(node2, new_Cost = -1){
    var newlink = new PathLink(this, node2, new_Cost);
    if($.isEmptyObject(newlink)){
      newlink = null;
    }else{
      this.links.push(newlink);
      node2.links.push(newlink);
    }
    return newlink;
  }
}
export default PathNode;